






import { Component, Prop } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class NewsletterRedirectForm extends BaseComponent {
    @Prop({ type: String, required: true }) protected readonly redirect: string;

    protected email: string | null = null;

    protected onSubmit(): void {
        document.location.href = this.email ? `${ this.redirect }?${ ['email', this.email].map(encodeURIComponent).join('=') }` : this.redirect;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NewsletterRedirectForm.vue